<div class="habits-dialog">
  <div class="dialog-header">
    <div class="header-content">
      <h2 class="dialog-title">{{ data.dayName }}, {{ data.date }}</h2>
    </div>
    <button mat-icon-button class="close-button" (click)="closeDialog()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="section" *ngIf="data.cards && data.cards.length > 0">
      <h3 class="section-title">Habits</h3>
      <div class="cards-container">
        <div class="habit-card" *ngFor="let c of data.cards">
          <div class="card-row first-row">
            <img *ngIf="c.habitIcon" [src]="c.habitIcon" alt="Habit icon" class="habit-icon" />
            <div class="habit-info">
              <div class="habit-name">{{ c.habitName }}</div>
              <div class="habit-title">{{ resolveTitle(c) }}</div>
            </div>
          </div>

          <div class="meta-row">
            <div class="meta-item">
              <span class="meta-label">Time</span>
              <span class="meta-value">{{ formatTime24To12(c.time) }}</span>
            </div>
            <div class="meta-item">
              <span class="meta-label">Status</span>
              <span class="meta-value" [class.done]="(c.status || '').toLowerCase() === 'done'" [class.missed]="(c.status || '').toLowerCase() === 'missed'" [class.pending]="(c.status || '').toLowerCase() === 'pending'">
                {{ c.status }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="no-data" *ngIf="!data.cards || data.cards.length === 0">
      <p>No entries found for this date.</p>
    </div>
  </div>
</div>

